export const CLAIM_REASONS = [
  "Producto defectuoso",
  "Producto incorrecto",
  "No llegó el pedido",
  "Producto incompleto",
  "Dañado en el envío",
  "Otro",
];

export const CLAIM_STATUS = {
  abierto: { label: "Abierto", cls: "bg-amber-100 text-amber-700" },
  en_revision: { label: "En revisión", cls: "bg-blue-100 text-blue-700" },
  esperando_cliente: { label: "Esperando tu respuesta", cls: "bg-orange-100 text-orange-700" },
  cerrado_sin_respuesta: { label: "Cerrado — sin respuesta", cls: "bg-gray-200 text-gray-600" },
  cambio_por_aceptar: { label: "Cambio propuesto", cls: "bg-violet-100 text-violet-700" },
  cambio_aceptado: { label: "Cambio aceptado", cls: "bg-violet-100 text-violet-700" },
  cambio_devolucion: { label: "Devuelve el producto", cls: "bg-indigo-100 text-indigo-700" },
  cambio_recibido: { label: "Devolución recibida", cls: "bg-indigo-100 text-indigo-700" },
  cambio_reemplazo: { label: "Reemplazo enviado", cls: "bg-teal-100 text-teal-700" },
  saldo_por_devolver: { label: "Devolución + saldo a favor", cls: "bg-emerald-100 text-emerald-700" },
  saldo_devolucion: { label: "Devuelve el producto", cls: "bg-indigo-100 text-indigo-700" },
  reembolso_por_devolver: { label: "Devolución + reembolso", cls: "bg-emerald-100 text-emerald-700" },
  reembolso_devolucion: { label: "Devuelve el producto", cls: "bg-indigo-100 text-indigo-700" },
  reembolso_por_registrar: { label: "Reembolso en proceso", cls: "bg-emerald-100 text-emerald-700" },
  cerrado: { label: "Cerrado", cls: "bg-[hsl(var(--meli-green))]/15 text-[hsl(var(--meli-green))]" },
};

export const claimStatusMeta = (s) => CLAIM_STATUS[s] || { label: s, cls: "bg-gray-100 text-gray-600" };

export const CLOSED_STATES = ["cerrado", "cerrado_sin_respuesta"];
